import type { EventListeners, Reactive } from "minze";
import { MinzeElement } from "minze";
import { Locale } from "../../../modules/locale";
import { EMAIL_REGEX, PHONE_REGEX } from "../../../modules/utils";
import { submitForm } from "../../../constants";
import { SquidexTextLabels } from '../../../modules/squidex/labels';

Locale.getInstance().registerKeySet("fr", "sexualityWorkshopForm", {
  title: "Cent réponses, sans tabous - sexualité",
});
Locale.getInstance().registerKeySet("en", "sexualityWorkshopForm", {
  title: "Cent réponses, sans tabous - sexualité",
});

export interface TjSexualityWorkshopForm {
  errors: { [fieldName: string]: string };
  values: { [fieldName: string]: any };
  submitted: boolean;
}
export class TjSexualityWorkshopForm extends MinzeElement {
  reactive: Reactive = [
    ["errors", {}],
    ["values", {}],
    ["submitted", false],
  ];
  private educationGroups = [
    {
      key: "Secondaire 1",
      id: "secondary1",
    },
    {
      key: "Secondaire 2",
      id: "secondary2",
    },
    {
      key: "Secondaire 3",
      id: "secondary3",
    },
    {
      key: "Secondaire 4",
      id: "secondary4",
    },
    {
      key: "Secondaire 5",
      id: "secondary5",
    },
    {
      key: "Adaptation scolaire",
      id: "specialEducation",
    },
  ];

  // TODO: Extract to a separate function for re-usability
  submitForm = async () => {
    if (this.submitted) {
      return;
    }
    const webhookId = "3ltz266";
    this.submitted = false;
    this.errors = {};
    const nameField = this.select(`#name`)?.getAttribute("value");
    const emailField = this.select(`#email`)?.getAttribute("value");
    const phoneField = this.select(`#phone`)?.getAttribute("value");
    const phoneExtensionField = this.select(`#phoneExtension`)?.getAttribute("value");
    const schoolField = this.select(`#school`)?.getAttribute("value");
    const regionField = this.select(`#region`)?.getAttribute("value");
    const datesRequestedField =
      this.select(`#datesRequested`)?.getAttribute("value");
    this.values = {
      name: nameField,
      email: emailField,
      phone: phoneField,
      phoneExtension: phoneExtensionField,
      school: schoolField,
      region: regionField,
      sixthGrade: this.select(`#sixthGrade`)?.getAttribute("value"),
      secondary1: this.select(`#secondary1`)?.getAttribute("value"),
      secondary2: this.select(`#secondary2`)?.getAttribute("value"),
      secondary3: this.select(`#secondary3`)?.getAttribute("value"),
      secondary4: this.select(`#secondary4`)?.getAttribute("value"),
      secondary5: this.select(`#secondary5`)?.getAttribute("value"),
      specialEducation: this.select(`#specialEducation`)?.getAttribute("value"),
      datesRequested: datesRequestedField,
    };
    if (!nameField) this.errors = { ...this.errors, name: SquidexTextLabels.getKey("workshopForm.errorMessages.required") };
    if (!emailField) this.errors = { ...this.errors, email: SquidexTextLabels.getKey("workshopForm.errorMessages.required") };
    else if (!EMAIL_REGEX.test(emailField)) {
      this.errors = { ...this.errors, email: SquidexTextLabels.getKey("workshopForm.errorMessages.invalidEmail") };
    }
    if (!nameField) this.errors = { ...this.errors, name: SquidexTextLabels.getKey("workshopForm.errorMessages.required") };
    if (!emailField) this.errors = { ...this.errors, email: SquidexTextLabels.getKey("workshopForm.errorMessages.required") };
    else if (!EMAIL_REGEX.test(emailField)) {
      this.errors = { ...this.errors, email: SquidexTextLabels.getKey("workshopForm.errorMessages.invalidEmail") };
    }
    if (!phoneField) this.errors = { ...this.errors, phone: SquidexTextLabels.getKey("workshopForm.errorMessages.required") };
    else if (!PHONE_REGEX.test(phoneField)) this.errors = { ...this.errors, phone: SquidexTextLabels.getKey("workshopForm.errorMessages.invalidPhone") };
    if (!schoolField) this.errors = { ...this.errors, school: SquidexTextLabels.getKey("workshopForm.errorMessages.required") };
    if (!regionField) this.errors = { ...this.errors, region: SquidexTextLabels.getKey("workshopForm.errorMessages.required") };
    if (!datesRequestedField) this.errors = { ...this.errors, datesRequested: SquidexTextLabels.getKey("workshopForm.errorMessages.required") };
    if (!Object.values(this.errors).length) {
      const response = await submitForm(webhookId, this.values);
      if (response.status === "success") {
        this.submitted = true;
        this.values = {};
      }
      this.submitted = true;
      this.values = {};
    }
    this.rerender();
  };

  renderForm = () => {
    return /*html*/ `
      <div class="contactInfoHeading">${SquidexTextLabels.getKey("workshopForm.contactInfoHeading")}</div>
      <tj-input
        id="name"
        name="name"
        placeholder="${SquidexTextLabels.getKey("workshopForm.fieldLabels.name")}"
        error="${this.errors["name"]}"
        value="${this.values["name"]}"
      ></tj-input>

      <tj-input
        id="email"
        name="email"
        type="email"
        placeholder="${SquidexTextLabels.getKey("workshopForm.fieldLabels.email")}"
        error="${this.errors["email"]}"
        value="${this.values["email"]}"
      ></tj-input>

      <div class="phoneInputsWrapper">
        <tj-input
          id="phone"
          name="phone"
          type="tel"
          placeholder="${SquidexTextLabels.getKey("workshopForm.fieldLabels.phone")}"
          error="${this.errors["phone"]}"
          value="${this.values["phone"]}"
        ></tj-input>

        <tj-input
          id="phoneExtension"
          name="phoneExtension"
          type="input"
          placeholder="${SquidexTextLabels.getKey("workshopForm.fieldLabels.phoneExtension")}"
          value="${this.values["phoneExtension"]}"
        ></tj-input>
      </div>

      <tj-input
        id="school"
        name="school"
        placeholder="${SquidexTextLabels.getKey("workshopForm.fieldLabels.school")}"
        error="${this.errors["school"]}"
        value="${this.values["school"]}"
      ></tj-input>

      <tj-select
        id="region"
        name="region"
        placeholder="${SquidexTextLabels.getKey("workshopForm.fieldLabels.region")}"
        default-value=""
        selectOptions="${SquidexTextLabels.getKey("workshopForm.fieldLabels.regionsOption")}"
        selectOptionLabels="${SquidexTextLabels.getKey("workshopForm.fieldLabels.regionsOption")}"
        error="${this.errors["region"]}"
        value="${this.values["region"]}"
      ></tj-select>

      <div class="educationGroupLabel">${SquidexTextLabels.getKey("workshopForm.educationGroupsHeading")}</div>
      <div class="educationGroupWrapper">
      ${this.educationGroups
        .map(
          (group: any) => /*html*/ `
        <tj-input type="number" id="${group.id}" name="${group.key}" value="${this.values[group.id]}" placeholder="${SquidexTextLabels.getKey(`workshopForm.educationGroups.${group.key}`)}"></tj-input>
        `
        )
        .join("")}
      </div>
      <tj-input
        id="datesRequested"
        name="datesRequested"
        placeholder="${SquidexTextLabels.getKey("workshopForm.fieldLabels.datesRequested")}"
        error="${this.errors["datesRequested"]}"
        value="${this.values["datesRequested"]}"
      ></tj-input>

      <tj-box mb="16px" display="flex" alignItems="center" justifyContent="space-between">
        <tj-button ${this.submitted && `disabled=true`} id="submit-form" name="submit" size="small" width="fit-content" fontWeight="700">
          ${SquidexTextLabels.getKey("workshopForm.submitButton")}
        </tj-button>
        ${this.submitted ? `<tj-text>${SquidexTextLabels.getKey("workshopForm.submittedMessage")}</tj-text>` : ""}
      </tj-box>
      `;
  };

  html = () => `
    <tj-popup-form-wrapper data-is-submitted="${this.submitted}">
      <div slot="open-popup-button">
        <tj-button id="open-button" name="open" size="large" fontWeight="700" width="100%">
          ${SquidexTextLabels.getKey("workshopForm.openFormButton")}
        </tj-button>
      </div>
      <div slot="title">${SquidexTextLabels.getKey("sexualityWorkshopForm.title")}</div>
      <div slot="content">
        ${this.renderForm()}
      </div>
    </tj-popup-form-wrapper>
  `;

  css = () => `
    tj-input, tj-select {
      margin-bottom: 1rem;
    }
    .phoneInputsWrapper {
      display: flex;
      gap: 0.25rem;
    }
    .educationGroupWrapper {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.5rem;
      border-top: 1px solid rgba(19, 55, 98, 0.2);
      border-bottom: 1px solid rgba(19, 55, 98, 0.2);
      padding-top: 1rem;
      padding-bottom: 1rem;
      margin-bottom: 1rem;
    }
    .educationGroupWrapper > tj-input {
      margin-bottom: 0;
    }
    .educationGroupLabel, .contactInfoHeading {
      margin-top: 1.5rem;
      font-size: 1.25rem;
      color: #133762;
    }
    .contactInfoHeading{
      border-bottom: 1px solid rgba(19, 55, 98, 0.2);
      margin-bottom: 1rem;
    }
  `;
  eventListeners: EventListeners = [["#submit-form", "click", this.submitForm]];
}
